var maxHueValue = 360;
var defaultSaturation = '50%';
var defaultLuminance = '50%'; // fast (non-secure) hashing solution
// https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript

var generateNumberHashFromString = function generateNumberHashFromString(nameString) {
  var stringLength = nameString.length;
  var hash = 0;

  if (stringLength === 0) {
    return hash;
  }

  for (var i = 0; i < stringLength; i++) {
    var char = nameString.charCodeAt(i);
    hash = (hash << 5) - hash + char; // eslint-disable-line

    hash |= 0; // eslint-disable-line
  }

  return hash;
};

var generateHSLColorFromHash = function generateHSLColorFromHash(numberHash, saturation, luminance) {
  var absHash = Math.abs(numberHash);
  var denominator = Math.pow(10, absHash.toString().length - 1);
  var hashAsFraction = absHash / denominator;
  var hue = Math.round(maxHueValue * hashAsFraction);
  return {
    h: hue,
    s: saturation,
    l: luminance
  };
};

var generateHSLColorFromString = function generateHSLColorFromString(stringValue) {
  var forceLowerCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var saturation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultSaturation;
  var luminance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultLuminance;

  if (forceLowerCase) {
    stringValue = stringValue.toLowerCase();
  }

  var numberHash = generateNumberHashFromString(stringValue);
  return generateHSLColorFromHash(numberHash, saturation, luminance);
};

export { generateHSLColorFromString };